import { Box, Button } from '@cad-arc';
import { useDrawerControls } from '../drawers/components/drawer-context-provider';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';

export function LogOnUnitButton(): React.ReactElement {
    const { logOnEditUnit } = useEnabledFeatures();
    const drawerControls = useDrawerControls();
    return logOnEditUnit ? (
        <Box ml="10">
            <Button
                variant="outline"
                type="button"
                size="sm"
                onClick={() => {
                    drawerControls.open({
                        type: 'log-on-edit-unit',
                        props: {},
                    });
                }}
            >
                Log On Unit
            </Button>
        </Box>
    ) : (
        <></>
    );
}
